import React from 'react';
import { fmtWeight } from '../utils/format';

export default function SharedView({ item, onZoom, loading }) {
  if (loading) {
    return (
      <div className="max-w-3xl mx-auto py-32 text-center">
        <div className="w-16 h-16 border-4 border-[#3B4D3C] border-t-transparent rounded-full animate-spin mx-auto mb-8"></div>
        <p className="font-serif italic text-2xl text-[#3B4D3C]">Laster delt fangst...</p>
      </div>
    );
  }

  if (!item) {
    return (
      <div className="max-w-3xl mx-auto py-32 text-center">
        <p className="font-serif italic text-2xl text-[#3B4D3C]">Fangst ikke funnet</p>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto space-y-16 py-20 px-4 text-center animate-in fade-in duration-1000">
      <div className="flex flex-col items-center gap-8">
        <div className="bg-[#F8F5F0] p-3 rounded-2xl rotate-3 shadow-2xl border-4 border-white/20">
          <img
            src="/logo-mark.webp"
            alt="FiskDa"
            width={72}
            height={72}
            className="w-[72px] h-[72px] object-contain block rounded-xl"
          />
        </div>
        <div className="space-y-2">
          <h2 className="font-serif italic text-4xl text-[#3B4D3C]">FiskDa</h2>
          <div className="inline-block px-10 py-3 bg-[#3B4D3C]/5 text-[#3B4D3C] rounded-full border border-[#3B4D3C]/10 text-[12px] font-black uppercase tracking-[0.6em] shadow-sm">
            Offisiell Rapport
          </div>
        </div>
      </div>

      <div 
        onClick={() => onZoom(item.image)} 
        className="relative rounded-sm overflow-hidden aspect-square shadow-2xl mx-auto border-8 border-white ring-1 ring-[#D1CCC0] cursor-zoom-in group max-w-lg"
      >
        <img 
          src={item.image} 
          className="w-full h-full object-cover grayscale-[0.1] transition-all duration-1000 group-hover:grayscale-0 group-hover:scale-105" 
          alt="Delt fangst" 
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-transparent to-transparent flex flex-col justify-end p-12 text-left">
          <h3 className="text-7xl font-serif font-black italic uppercase leading-[0.8] tracking-tighter text-white mb-8">
            {item.species}
          </h3>
          <div className="flex justify-between items-end border-t border-white/20 pt-8 opacity-90 text-white">
            {item.weight && (
              <div>
                <p className="text-[10px] font-black uppercase text-white/50 tracking-widest mb-1">Vekt</p>
                <p className="text-4xl font-serif font-black italic text-[#E67E22]">{fmtWeight(item.weight)}</p>
              </div>
            )}
            <div className="text-right">
              <p className="text-[10px] font-black uppercase text-white/50 tracking-widest mb-1">Dato</p>
              <p className="text-2xl font-serif italic">
                {new Date(item.caughtAt).toLocaleDateString('no-NO')}
              </p>
              {item.time && (
                <p className="font-serif italic text-sm text-white/60 mt-1">
                  {item.time.includes(':') ? item.time : `${item.time.slice(0,2)}:${item.time.slice(2)}`}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>

      <button 
        onClick={() => window.location.href = window.location.origin + window.location.pathname} 
        className="bg-[#3B4D3C] text-[#F8F5F0] px-14 py-6 rounded shadow-2xl font-serif font-black italic text-lg tracking-[0.2em] hover:scale-105 active:scale-95 transition-all"
      >
        Start din egen loggbok
      </button>
    </div>
  );
}